import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DateFormat } from "@/components/atoms";
import { GrayCard, RefValue } from "@/components/molecules";
import { GrayCardProps } from "@/components/molecules/Cards/GrayCard/GrayCard";

import { CompanyFormType } from "../../../../formType";
import { StyledCardItem, StyledCardList } from "../styled";

const GeneralCard: FC<GrayCardProps> = ({ onEdit }) => {
    const { t } = useTranslation();
    const { getValues } = useFormContext<CompanyFormType>();
    const {
        name,
        foundationDate,
        legalForm,
        lastStatuteChangeDate,
        language,
        nationality,
        enterpriseNumber,
        establishmentNumber,
        nssoRegistrationNumber,
        amountOfStaff,
        amountOfEmployees,
        amountOfWorkers,
    } = getValues("general");

    return (
        <GrayCard title={t("Common.General")} onEdit={onEdit}>
            <StyledCardList>
                <StyledCardItem $size={2}>
                    <span>{t("Common.Name")}</span>
                    <span>{name || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.FoundationDate")}</span>
                    <span>
                        <DateFormat date={foundationDate} fallback="-" />
                    </span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.LegalForm")}</span>
                    <span>{legalForm ? <RefValue table="legalStatus" value={legalForm} /> : "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.LastUpdatedDate")}</span>
                    <span>
                        <DateFormat date={lastStatuteChangeDate} fallback="-" />
                    </span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.Language")}</span>
                    <span>{language ? <RefValue table="language" value={language} /> : "-"}</span>
                </StyledCardItem>
                <StyledCardItem $size={2}>
                    <span>{t("Common.Nationality")}</span>
                    <span>{nationality ? <RefValue table="nationality" value={nationality} /> : "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.EnterpriseNumber")}</span>
                    <span>{enterpriseNumber || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.EstablishmentNumber")}</span>
                    <span>{establishmentNumber || "-"}</span>
                </StyledCardItem>
                <StyledCardItem $size={2}>
                    <span>{t("Common.RSZRegistrationNumber")}</span>
                    <span>{nssoRegistrationNumber || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.NumberOfEmployees")}</span>
                    <span>{amountOfStaff || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.NumberOfClerks")}</span>
                    <span>{amountOfEmployees || "-"}</span>
                </StyledCardItem>
                <StyledCardItem>
                    <span>{t("Common.NumberOfLabourers")}</span>
                    <span>{amountOfWorkers || "-"}</span>
                </StyledCardItem>
            </StyledCardList>
        </GrayCard>
    );
};

export default GeneralCard;
